import { Controller } from '@hotwired/stimulus'

// Fade-in-on-scroll for `.reveal` elements on flamingOS landing pages.
// Elements mark themselves as `data-fos-reveal-target="reveal"`; they gain
// the `.v` class as they enter the viewport. Already-visible elements are
// revealed on the next frame so the initial paint stays animated but never blocks.
export default class extends Controller {
  static targets = ['reveal']

  disconnect () {
    this.observer?.disconnect()
  }

  revealTargetConnected (el) {
    if (!this.observer) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('v')
          this.observer.unobserve(entry.target)
        })
      }, { threshold: 0.01, rootMargin: '0px 0px 50px 0px' })
    }

    requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect()
      if (rect.top < window.innerHeight + 50) {
        el.classList.add('v')
      } else {
        this.observer.observe(el)
      }
    })
  }
}
